import localstorage from 'src/helper/localstorage'

/**
 * 设置网页标题
 * @param args
 */
export const setTitle = function (title) {
  document.title = title
}
/**
 * 获取app应用内容
 * @returns {*}
 */
/**
 * BS2 image缩略图接口
 * http://wiki.yy.com/index.php/BS2_image%E7%BC%A9%E7%95%A5%E5%9B%BE%E6%8E%A5%E5%8F%A3
 * @param url
 * @param w
 * @param h
 * @param mod
 * @returns {string}
 */
export const bs2 = function (url, w, h, mod) {
  mod = mod || 0
  url = `${url}?ips_thumbnail/${mod}`
  if (w) {
    url += `/w/${w}`
  }
  if (h) {
    url += `/h/${h}`
  }
  return url
}


// WEBPACK FOOTER //
// ./helper/platform.js